module.exports = __webpack_public_path__ + "img/background-image.39e41023.jpg";